export default __webpack_public_path__ + "static/media/about_me_2.3b72a346.jpg";